export default "__VITE_ASSET__B7GCsbj1__"